export default __webpack_public_path__ + "static/media/cloud-2@2x.191d74db.png";